import { render, staticRenderFns } from "./FlashCardLogo.vue?vue&type=template&id=477d3b7f&scoped=true&"
import script from "./FlashCardLogo.vue?vue&type=script&lang=js&"
export * from "./FlashCardLogo.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardLogo.vue?vue&type=style&index=0&id=477d3b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d3b7f",
  null
  
)

export default component.exports